export class Constants {
	static readonly version = '0.0.2';
}
